import React from 'react';
import { observer } from 'mobx-react';
import { EligibilityStatusListTemplate } from 'themes/application/eligibility-status/pages';
import { setCurrentView } from 'core/utils';
import { EligibilityStatusListViewStore } from 'application/eligibility-status/stores';

@setCurrentView((rootStore) => new EligibilityStatusListViewStore(rootStore), 'eligibilityStatusListViewStore')
@observer
class EligibilityStatusList extends React.Component {
    render() {
        return <EligibilityStatusListTemplate {...this.props} />
    }
}

export default EligibilityStatusList;